<template>
  <div class="blockContainer bg-white">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BlockContainer',
  props: {
    hasHover: {
      type: Boolean,
      default: false,
    },
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.blockContainer {
  border-radius: 12px;
  border: 1px solid $gray-200;
}
</style>
